<fgb-banner [pageTitle]="'contact.us.page.title' | translate" />

<fgb-page-header [pageTitle]="'contact.us.page.title'" [showBalance]="false" [backButtonLink]="'/'"></fgb-page-header>

<!--Contact Box-->
<fgbcl-contact-us></fgbcl-contact-us>
